import React, { useState, useEffect } from 'react';
import '../../styles/modal.css';

interface PWAInstallDialogProps {
  show: boolean;
  onClose: () => void;
  onInstall: () => Promise<boolean>;
}

const PWAInstallDialog: React.FC<PWAInstallDialogProps> = ({ show, onClose, onInstall }) => {
  const [showManualInstructions, setShowManualInstructions] = useState(false);

  const handleInstall = async () => {
    const success = await onInstall();
    // If automatic install failed, show manual instructions
    if (!success) {
      setShowManualInstructions(true);
    }
  };

  const getManualInstructions = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    
    if (isIOS) {
      return (
        <div className="manual-install-instructions">
          <h4>Install on iOS:</h4>
          <ol>
            <li>Tap the Share button <span style={{fontSize: '18px'}}>⬆️</span> in Safari</li>
            <li>Scroll down and tap "Add to Home Screen"</li>
            <li>Tap "Add" to install the app</li>
          </ol>
        </div>
      );
    } else if (isAndroid) {
      return (
        <div className="manual-install-instructions">
          <h4>Install on Android:</h4>
          <ol>
            <li>Tap the menu button (⋮) in your browser</li>
            <li>Look for "Add to Home screen" or "Install app"</li>
            <li>Tap "Add" or "Install" to install the app</li>
          </ol>
        </div>
      );
    } else {
      return (
        <div className="manual-install-instructions">
          <h4>Install on Desktop:</h4>
          <ol>
            <li>Look for an install icon in your browser's address bar</li>
            <li>Or use your browser's menu to find "Install" or "Add to Desktop"</li>
            <li>Follow the prompts to install the app</li>
          </ol>
        </div>
      );
    }
  };

  if (!show) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-container pwa-install-modal">
        <div className="modal-content">
          {!showManualInstructions ? (
            <>
              <h3>Install App</h3>
              <p>
                Get the best experience by installing our app on your device. 
                You'll be able to access it quickly from your home screen!
              </p>
              <div className="modal-actions">
                <button 
                  className="modal-button secondary" 
                  onClick={onClose}
                >
                  Nope
                </button>
                <button 
                  className="modal-button primary" 
                  onClick={handleInstall}
                >
                  Yep
                </button>
              </div>
            </>
          ) : (
            <>
              <h3>Install App Manually</h3>
              {getManualInstructions()}
              <div className="modal-actions">
                <button 
                  className="modal-button primary" 
                  onClick={onClose}
                >
                  Got it!
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PWAInstallDialog;
